
define('app/dashboard/leagues/instances/views/lgUsersView',[
	'jquery',
	'underscore',
	'backbone',
	'known/models/userModel',
	'known/models/leagueInstanceModel',
	'known/models/leagueUserModel',
	
	//Templates
	'text!app/dashboard/leagues/instances/templates/lgUserTemplate.html'
], function(
		$, 
		_, 
		Backbone, 
		UserModel, 
		LeagueInstanceModel,
		LeagueUserModel,
		lgUserHtml){
	
	var LgUserListItemMessageView = Backbone.View.extend({
		initialize: function(options) {
			this.hideAll();
			
			this.event = options.event;
			
			this.listenTo(this.event, 'saving', this.processing);
			this.listenTo(this.event, 'error', this.error);
			this.listenTo(this.event, 'success', this.success);
		},
		
		hideAll: function() {
			$(this.el).hide();
			this.$(".draftUserMessageError").hide();
			this.$(".draftUserMessageProcessing").hide();
			this.$(".draftUserMessageSuccess").hide();
		},
		
		error: function () {
			this.hideAll();
			$(this.el).show();
			this.$(".draftUserMessageError").show();
		},
		
		success: function () {
			this.hideAll();
			$(this.el).show();
			this.$(".draftUserMessageSuccess").show();
			this.$(".draftUserMessageSuccess").fadeOut(3000);
		},
		
		processing: function () {
			this.hideAll();
			$(this.el).show();
			this.$(".draftUserMessageProcessing").show();
		},
	    
	    destroyView: function() {
	    	this.stopListening();
	    	this.undelegateEvents();
        }
	});
	
	var LgUserListItemView = Backbone.View.extend({
		initialize: function(options) {
			this.lgInstance = options.lgInstance;
			this.lgUser = options.lgUser;
			this.userModel = options.userModel;
			this.userEvent = options.userEvent;
			
			this.event = _.extend({}, Backbone.Events);
			this.submittedData = {isSubmitted : false};
			
			_.bindAll(this, 'hideView');
			_.bindAll(this, 'showView');
			_.bindAll(this, 'submitForm');
			_.bindAll(this, 'successCallback');
			_.bindAll(this, 'errorCallback');
			
			this.lgUserTemplate = _.template(lgUserHtml.trim());
			
			this.buildEl();
			
			this.message = new LgUserListItemMessageView({el: this.$(".draftUserMessage"), event: this.event});
			
			this.listenTo(this.event, 'save', this.submitChange);
			this.listenTo(this.event, 'saving', this.hideView);
			this.listenTo(this.event, 'error', this.showView);
			this.listenTo(this.event, 'success', this.hideView);
		},
		
		render: function () {
			
			return this;
		},
		
		submitChange: function () {
			if(!this.submittedData.isSubmitted){
				this.event.trigger("saving");
				
				this.submittedData.isSubmitted = true;
				this.lgUser.save({
					leagueUserRole: this.$(".draftUserRoleSelInput").val()
				},{wait: true,
					success : this.successCallback, 
					error : this.errorCallback
				});
			}
		},
		
		successCallback: function(model, response) {
			if(this.submittedData.isSubmitted){
				this.submittedData.isSubmitted = false;
				this.event.trigger("success");
				this.userEvent.trigger("refreshUsers");
			}
		},
		
		errorCallback: function(model, error) {
			if(this.submittedData.isSubmitted){
				if (error.status == 400) {
					//Input errors
					this.event.trigger("error");
					
					var errObj = JSON.parse(error.responseText);
					
					if(errObj.code){
						for(var i=0; i< errObj.code.length; i++){
							if(errObj.code[i].indexOf("_") > 0){
								//Trigger a specific event for the field with the code attached as a param
								var errCode = errObj.code[i].substring(0, errObj.code[i].indexOf("_"));
								var field = errObj.code[i].substring(errObj.code[i].indexOf("_") + 1);
								this.event.trigger("error:" + field.toLowerCase(), errCode);
							}
						}
					}
				} else {
					this.event.trigger("error");
				}
				
				this.submittedData.isSubmitted = false;
			}
		},
		
		buildEl: function() {
			this.setElement($(this.lgUserTemplate({
					userName: this.lgUser.prettyDispName(),
					lgUserId: this.lgUser.get('id')
				})));
			
			this.setupDropdown();
			this.setupEditing();
			
			$(this.el).find(".draftUserFormSubmit").on('click', this.submitForm);
		},
		
		setupDropdown: function () {
			if(this.lgUser.get('leagueUserRole') != "COMMISH"){
				this.$(".draftUserRoleSelInput").val(this.lgUser.get('leagueUserRole'));
			}			
			
			$(this.el).find('.styled').uniform({radioClass: 'choice', selectAutoWidth: false});
		},
		
		setupEditing: function() {
			$(this.el).find('.doubleMarginActionBtn').on('click', {}, this.showView);
			$(this.el).find('.draftUserFormCancel').on('click', {}, this.hideView);
			
			if(this.lgInstance.isCommissioner(this.userModel.get('userName')) && this.lgUser.get('leagueUserRole') != "COMMISH"){
				$(this.el).find('.doubleMarginActionBtn').show();
			} else {
				$(this.el).find('.doubleMarginActionBtn').hide();
			}
		},
		
		submitForm: function () {
			this.event.trigger("save");
		},
		
		hideView: function() {
			$(this.el).find('.doubleMarginActionBtn').show();
			$(this.el).find('.draftUserRoleForm').slideUp();
		},
		
		showView: function() {
			$(this.el).find('.doubleMarginActionBtn').hide();
			$(this.el).find('.draftUserRoleForm').slideDown();
		},
	    
	    destroyView: function() {
	    	this.stopListening();
	    	this.undelegateEvents();
	    	
	    	//Remove DOM
	    	$(this.el).removeData().unbind();
	    	this.remove();  
	    	Backbone.View.prototype.remove.call(this);
        }
	});
	
	var LgUserRoleListView = Backbone.View.extend({
		initialize: function(options) {
			this.lgInstance = options.lgInstance;
			this.users = options.users;
			this.userModel = options.userModel;
			this.userEvent = options.userEvent;
			
			this.defaultContainer = $(this.el).find('.draftUserDefaultContainer');
			this.userListContainer = $(this.el).find('.draftUserListContainer');
			
			this.lgUserListItemViews = [];
		},
		
		render: function () {
			this.renderList();
			
			return this;
		},
		
		updateUsers: function(userList) {
			this.users = userList;
			
			this.render();
		},
		
		renderList: function() {
			this.hideAll();
			
			this.removeAllLgUserItems();
			this.userListContainer.empty();
			this.addAllLgUserItems();
		},
		
		removeAllLgUserItems: function() {
			_.each(this.lgUserListItemViews, function(view, key){
				this.lgUserListItemViews[key].destroyView();
				delete this.lgUserListItemViews[key];
			}, this);
		},
		
		addLgUserListItem: function(lgUser) {
			var view = new LgUserListItemView({
				lgInstance: this.lgInstance,
				lgUser: lgUser,
				userModel: this.userModel,
				userEvent: this.userEvent});
			this.userListContainer.append(view.render().el);
			this.lgUserListItemViews[lgUser.cid] = view;
		},
		
		addAllLgUserItems: function() {
			if(_.size(this.users) > 0){
				_.each(this.users, function(lgUser){
					this.addLgUserListItem(lgUser);
				}, this);
				
				this.userListContainer.show();
			} else {
				this.defaultContainer.show();
			}
		},
		
		hideAll: function () {
			this.defaultContainer.hide();
			this.userListContainer.hide();
		},
	    
	    destroyView: function() {
	    	this.removeAllLgUserItems();
	    	
	    	this.stopListening();
	    	this.undelegateEvents();
        }
	});
	
	var LgUsersView = Backbone.View.extend({
		el: $("#draftUserGrp"),
		
		initialize: function(options) {
			this.userModel = options.userModel; 
			this.lgInstance = options.lgInstance;
			
			this.userEvent = _.extend({}, Backbone.Events);
			
			this.commissionersView = new LgUserRoleListView({
				el: this.$("#draftUserCommishList"),
				lgInstance: this.lgInstance,
				users: this.lgInstance.getCommissionerUsers(),
				userModel: this.userModel,
				userEvent: this.userEvent});
			this.assistantsView = new LgUserRoleListView({
				el: this.$("#draftUserAssistantList"),
				lgInstance: this.lgInstance,
				users: this.lgInstance.getAssistantUsers(),
				userModel: this.userModel,
				userEvent: this.userEvent});
			this.managersView = new LgUserRoleListView({
				el: this.$("#draftUserManagerList"),
				lgInstance: this.lgInstance,
				users: this.lgInstance.getManagerUsers(),
				userModel: this.userModel,
				userEvent: this.userEvent});
			
			this.listenTo(this.userEvent, 'refreshUsers', this.update);
		},
		
		render: function () {
			this.commissionersView.render();
			this.assistantsView.render();
			this.managersView.render();
			
			return this;
		},
		
		update: function() {
			this.commissionersView.updateUsers(this.lgInstance.getCommissionerUsers());
			this.assistantsView.updateUsers(this.lgInstance.getAssistantUsers());
			this.managersView.updateUsers(this.lgInstance.getManagerUsers());
		}
	});
	
	return LgUsersView;  
});